import React from "react";
import { ShieldWarning, SignIn } from "@phosphor-icons/react";

export const openSignIn = () => window.dispatchEvent(new CustomEvent("farmwatch:open-auth", { detail: "login" }));

export const AdminAccessNotice = ({ user, area = "this admin area" }) => (
  <div className="max-w-[700px] mx-auto px-4 py-20 text-center" data-testid="admin-access-notice">
    <ShieldWarning size={48} className="text-[#DC2626] mx-auto mb-4" />
    <h1 className="font-serif text-2xl text-[#111827] mb-2">{user ? "Admin access required" : "Sign in to continue"}</h1>
    {user ? (
      <p className="text-[#6B6661] text-sm" data-testid="admin-access-not-admin">
        You are signed in as <strong>{user.email}</strong>, which is not an admin account. Admin rights belong to the
        account set as <code className="bg-[#F3F4F6] px-1">ADMIN_EMAIL</code> in the backend's Railway variables — sign
        out and sign in with that account, or set ADMIN_EMAIL / ADMIN_PASSWORD in Railway and redeploy.
      </p>
    ) : (
      <>
        <p className="text-[#6B6661] text-sm mb-6">Use the admin account to open {area}.</p>
        <button onClick={openSignIn} data-testid="admin-access-signin-btn"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#111827] text-white text-sm font-semibold hover:bg-[#0F766E] transition-colors">
          <SignIn size={18} /> Sign in
        </button>
      </>
    )}
  </div>
);
